<template>
    <div class="demo-inline-spacing float-right">
        <b-button
            :disabled="!showSendButton"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-0"
            @click="request"
        >
            {{ $t('Component(Button):send') }}
        </b-button>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-0"
            @click="back"
        >
            {{ $t('Component(Button):back') }}
        </b-button>
    </div>
</template>
<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
    components: {
        BButton
    },
    directives: {
        Ripple
    },
    props: {
        showSendButton: {
            default: true,
            type: Boolean
        }
    },
    methods: {
        back() {
            this.$emit('back');
        },
        request() {
            this.$emit('sendRequest')
        }
    }
}
</script>
